import { render } from "./PositionalTextGen.vue?vue&type=template&id=14545b02"
import script from "./PositionalTextGen.vue?vue&type=script&lang=js"
export * from "./PositionalTextGen.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__